(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 18463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79895);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);







var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Paper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiCard'
})(Card));

/***/ }),

/***/ 79912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1591);






var styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  }
};
var CardContent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CardContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles, {
  name: 'MuiCardContent'
})(CardContent));

/***/ }),

/***/ 94697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 16
  },

  /* Styles applied to the avatar element. */
  avatar: {
    flex: '0 0 auto',
    marginRight: 16
  },

  /* Styles applied to the action element. */
  action: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -8,
    marginRight: -8
  },

  /* Styles applied to the content wrapper element. */
  content: {
    flex: '1 1 auto'
  },

  /* Styles applied to the title Typography element. */
  title: {},

  /* Styles applied to the subheader Typography element. */
  subheader: {}
};
var CardHeader = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CardHeader(props, ref) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      subheaderProp = props.subheader,
      subheaderTypographyProps = props.subheaderTypographyProps,
      titleProp = props.title,
      titleTypographyProps = props.titleTypographyProps,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);

  var title = titleProp;

  if (title != null && title.type !== _Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && !disableTypography) {
    title = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      variant: avatar ? 'body2' : 'h5',
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps), title);
  }

  var subheader = subheaderProp;

  if (subheader != null && subheader.type !== _Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && !disableTypography) {
    subheader = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "textSecondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps), subheader);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className),
    ref: ref
  }, other), avatar && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.avatar
  }, avatar), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.content
  }, title, subheader), action && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.action
  }, action));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiCardHeader'
})(CardHeader));

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(68497);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67265);


var CustomAvatar = function(param) {
    var children = param.children, className = param.className, firstName = param.firstName, lastName = param.lastName, url = param.url, variant = param.variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: className,
        alt: [
            firstName,
            lastName
        ].join(" "),
        src: url,
        variant: variant,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomAvatar);


/***/ }),

/***/ 27908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59693);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);







var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            fontFamily: theme.typography.fontFamily,
            alignItems: "center",
            borderRadius: 2,
            display: "inline-flex",
            flexGrow: 0,
            whiteSpace: "nowrap",
            cursor: "default",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(12),
            fontWeight: theme.typography.fontWeightMedium,
            height: 20,
            justifyContent: "center",
            letterSpacing: 0.5,
            minWidth: 20,
            padding: theme.spacing(0.5, 1),
            textTransform: "uppercase"
        },
        primary: {
            color: theme.palette.primary.main,
            backgroundColor: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.primary.main, 0.08)
        },
        secondary: {
            color: theme.palette.secondary.main,
            backgroundColor: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.secondary.main, 0.08)
        },
        error: {
            color: theme.palette.error.main,
            backgroundColor: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.error.main, 0.08)
        },
        success: {
            color: theme.palette.success.main,
            backgroundColor: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.success.main, 0.08)
        },
        warning: {
            color: theme.palette.warning.main,
            backgroundColor: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* .alpha */ .Fq)(theme.palette.warning.main, 0.08)
        }
    };
});
var Label = function(_param) {
    var className = _param.className, color = _param.color, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "color",
        "children"
    ]);
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.root, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, classes[color], color), className)
    }, rest), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Label);


/***/ }),

/***/ 22238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_helmet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64593);






var Page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, _title = _param.title, title = _title === void 0 ? "" : _title, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "title"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref
    }, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet__WEBPACK_IMPORTED_MODULE_2__/* .Helmet */ .q, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: title
                })
            }),
            children
        ]
    }));
});
Page.displayName = "Page";
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 28300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16204);


var getColor = function(status) {
    if (status === "member") {
        return "primary";
    }
    if (status === "rejected" || status === "banned") {
        return "secondary";
    }
    return "default";
};
var StatusChip = function(param) {
    var label = param.label, status = param.status;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: "small",
        label: label,
        color: getColor(status)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StatusChip);


/***/ }),

/***/ 4854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);






var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return {
        root: {
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline"
            }
        }
    };
});
var TypographyLink = function(_param) {
    var as = _param.as, href = _param.href, className = _param.className, _color = _param.color, color = _color === void 0 ? "primary" : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "as",
        "href",
        "className",
        "color"
    ]);
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: as,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.root, className),
            component: "a",
            color: color
        }, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TypographyLink);


/***/ }),

/***/ 55442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95477);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88841);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);






var withAuth = function(WrappedComponent) {
    var ComponentWithAuth = function(props) {
        var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), asPath = ref.asPath, push = ref.push;
        var ref1 = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useMeQuery */ .UEB)(), loading = ref1.loading, data = ref1.data;
        if (loading) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    height: "100vh",
                    width: "100%",
                    display: "grid",
                    placeItems: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
            });
        }
        if (!(data === null || data === void 0 ? void 0 : data.me)) {
            push({
                pathname: "/login",
                query: {
                    redirectTo: asPath
                }
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            viewer: data.me
        }));
    };
    return ComponentWithAuth;
};
/* harmony default export */ __webpack_exports__["Z"] = (withAuth);


/***/ }),

/***/ 90358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    inRange: {
        color: "#72c89e",
        fontWeight: "bold"
    }
});
var ageInRange = function(age) {
    return age ? age >= 18 && age <= 30 || age >= 60 : null;
};
var Age = function(param) {
    var birthdate = param.birthdate;
    var classes = useStyles();
    var age = birthdate ? moment__WEBPACK_IMPORTED_MODULE_1___default()().diff(birthdate, "year") : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ageInRange(age) && classes.inRange),
        children: age
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Age);


/***/ }),

/***/ 68497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(94697);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./src/components/atoms/Page/index.tsx
var Page = __webpack_require__(22238);
// EXTERNAL MODULE: ./src/components/templates/Payments/index.tsx + 4 modules
var Payments = __webpack_require__(50493);
// EXTERNAL MODULE: ./src/generated/graphql.tsx + 16 modules
var graphql = __webpack_require__(88841);
// EXTERNAL MODULE: ./src/lib/redux/notifications/index.ts + 7 modules
var notifications = __webpack_require__(55206);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(17196);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(57394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Badge/Badge.js
var Badge = __webpack_require__(59009);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(56847);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(82302);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(83750);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(99613);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Visibility.js
var Visibility = __webpack_require__(20067);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(28270);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/atoms/Avatar/index.tsx
var Avatar = __webpack_require__(26429);
// EXTERNAL MODULE: ./src/components/atoms/StatusChip/index.tsx
var StatusChip = __webpack_require__(28300);
// EXTERNAL MODULE: ./src/lib/utils.ts
var utils = __webpack_require__(86269);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/templates/Users/Age.tsx
var Age = __webpack_require__(90358);
;// CONCATENATED MODULE: ./src/components/templates/Dashboard/birthdays.tsx











var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        avatar: {
            marginRight: theme.spacing(2)
        },
        table: {
            overflow: "hidden"
        },
        tableRow: {
            cursor: "pointer"
        },
        hostBadge: {
            "& span": {
                backgroundColor: "#72c89e"
            }
        },
        published: {
            color: "#72c89e"
        },
        unpublished: {
            color: "#f26b5b"
        },
        visibilityIcon: {
            fontSize: 12,
            marginLeft: -15,
            marginTop: 30
        }
    };
});
var StyledTableCell = (0,withStyles/* default */.Z)({
    sizeSmall: {
        padding: 6,
        "&:first-child": {
            paddingLeft: 16
        }
    }
})(TableCell/* default */.Z);
var getTypeLetter = function(user) {
    if (user.type) {
        return String.prototype.toUpperCase.call(user.type)[0];
    }
};
var UserBirthday = function(param) {
    var user = param.user;
    var ref, ref1, ref2, ref3;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/users/[id]",
        as: "/users/".concat(user.id),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
            hover: true,
            className: classes.tableRow,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        alignItems: "center",
                        display: "flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            container: true,
                            spacing: 2,
                            alignItems: "center",
                            wrap: "nowrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                        overlap: "rectangular",
                                        badgeContent: ((ref = user.profile.avatar) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)(classes.visibilityIcon, classes.published)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {
                                            className: (0,clsx_m/* default */.Z)(classes.visibilityIcon, classes.unpublished)
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                            color: user.type === graphql/* Roles.Host */.G72.Host ? "secondary" : "primary",
                                            className: user.type === graphql/* Roles.Host */.G72.Host ? classes.hostBadge : undefined,
                                            overlap: "circular",
                                            badgeContent: getTypeLetter(user),
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "right"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                className: classes.avatar,
                                                firstName: user.firstName,
                                                lastName: user.lastName,
                                                url: (ref1 = user.profile) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.avatar) === null || ref2 === void 0 ? void 0 : ref2.url,
                                                children: (0,utils/* getInitials */.Qm)("".concat(user.firstName, " ").concat(user.lastName))
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusChip/* default */.Z, {
                                        label: user.status[0].toUpperCase(),
                                        status: user.status
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "textPrimary",
                                    variant: "body1",
                                    children: "".concat(user.firstName, " ").concat(user.lastName)
                                })
                            }),
                            user.bannedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusChip/* default */.Z, {
                                    label: "B",
                                    status: "banned"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Age/* default */.Z, {
                        birthdate: (ref3 = user.profile) === null || ref3 === void 0 ? void 0 : ref3.birthdate
                    })
                })
            ]
        })
    });
};
var Birthdays = function(param) {
    var users = param.users;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
            size: "small",
            className: classes.table,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                    children: users.map(function(user) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBirthday, {
                            user: user
                        }, user.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var birthdays = (Birthdays);

;// CONCATENATED MODULE: ./src/components/templates/Dashboard/index.tsx









var addNotifications = notifications/* actions.addNotifications */.Nw.addNotifications;
var Dashboard_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        root: {
            backgroundColor: theme.palette.background.dark,
            minHeight: "100%",
            paddingBottom: theme.spacing(3),
            paddingTop: theme.spacing(3)
        }
    };
});
var Progress = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        justifyContent: "space-around",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            item: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
        })
    });
};
var BirthdaysContent = function(param) {
    var loading = param.loading, users = param.users;
    if (loading || !users) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(birthdays, {
        users: users
    });
};
var Dashboard = function(param) {
    var viewer = param.viewer;
    var classes = Dashboard_useStyles();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,graphql/* useUsersWithBirthdayQuery */.$9K)(), loadingUsersWithBirthday = ref.loading, errorUsersWithBirthday = ref.error, dataUsersWithBirthday = ref.data;
    if (errorUsersWithBirthday) {
        dispatch(addNotifications([
            {
                severity: "error",
                message: errorUsersWithBirthday.message
            }
        ]));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        className: classes.root,
        title: "Dashboard",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 3,
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                color: "textPrimary",
                                children: "Welcome, ".concat(viewer === null || viewer === void 0 ? void 0 : viewer.firstName)
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mt: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                                title: "Birthdays (".concat(moment_default()().format("YYYY-MM-DD"), ")")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BirthdaysContent, {
                                    loading: loadingUsersWithBirthday,
                                    users: dataUsersWithBirthday === null || dataUsersWithBirthday === void 0 ? void 0 : dataUsersWithBirthday.usersWithBirthday
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mt: 3,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                                title: "Last payments"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Payments/* default */.Z, {})
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var templates_Dashboard = (Dashboard);

// EXTERNAL MODULE: ./src/components/hooks/withAuth/index.tsx
var withAuth = __webpack_require__(55442);
;// CONCATENATED MODULE: ./src/pages/index.tsx



var DashboardPage = function(param) {
    var viewer = param.viewer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(templates_Dashboard, {
        viewer: viewer
    });
};
/* harmony default export */ var pages = ((0,withAuth/* default */.Z)(DashboardPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,5215,4407,2922,1574,8281,3741,493,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);